// extracted by mini-css-extract-plugin
export default {"meetTheTeam":"meetTheTeam_meetTheTeam__3Y4DE","imageDiv":"meetTheTeam_imageDiv__lPgB0"};